export default "__VITE_ASSET__BogENlQt__"